import baseURL from "@/utils/config"
import request from "@/plugins/axios"
const langEnv = window.localStorage.getItem("langEnv")
// 列表
export function getExchangeList (data) {
  return request({
    url: `${baseURL.api}/api/product/getExchangeList`,
    method: "post",
    data,
  })
}
export function getShoppingCartExchange (data) {
  return request({
    url: `${baseURL.api}/authapi/shoppingcart/getShoppingCartExchange`,
    method: "post",
    data,
  })
}
// 单品换购添加
export function addShoppingCartExchange (data) {
  return request({
    url: `${baseURL.api}/authapi/shoppingcart/addShoppingCartExchange`,
    method: "post",
    data,
  })
}
// 单品换购删除
export function deleteShoppingCartExchange (data) {
  return request({
    url: `${baseURL.api}/authapi/shoppingcart/deleteShoppingCartExchange`,
    method: "post",
    data,
  })
}
// 清空换购购物车商品
export function deleteShoppingCartExchangeList (data) {
  return request({
    url: `${baseURL.api}/authapi/shoppingcart/deleteShoppingCartExchangeList`,
    method: "post",
    data,
  })
}
